import axios from "axios";
import { ACTIVATE_GROUP_BY_ID_URL } from "../../constants";
import { editGroupByIndex } from "../../redux/group/groupActions";

const handleActivateGroup = async (group, jwt, dispatch) => {
    try {
        const response = await axios.patch(
            ACTIVATE_GROUP_BY_ID_URL.replace(":id", group.id),
            null, // sending null here as we don't want to send any data
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        );

        if (response.status === 200) {
            const updatedGroup = response.data.group;
            dispatch(editGroupByIndex(updatedGroup, updatedGroup.id));

            return { success: true };
        }
        return { success: false, error: response };
    } catch (error) {
        return { success: false, error: error.response.data.error };
    }
};
export default handleActivateGroup;
